export default function isAuthError(error) {
  let result = false;
  error?.graphQLErrors?.forEach(gqlError => {
    if (gqlError.extensions?.code === 'UNAUTHENTICATED') {
      result = true;
    }
  });
  return result;
}
